
























import { Component, Vue } from 'vue-property-decorator';
import Service from "./Service.vue";
import ServicesObject from "../../assets/jsons/Services.json";

@Component({
  components: {
    Service,
  },
})
export default class Services extends Vue {
  services: any[] = [];
  getServices() {
      this.services = ServicesObject;
  }
  mounted() {
    this.getServices()
  }
}
